// Share refreshes: Passport rotates refresh tokens, so parallel renewals must be avoided.
export function createAuthFailureHandler({ client, getToken, refresh, logout }) {
    let pendingRefresh = null;
    let pendingLogout = null;

    const endSession = () => {
        if (!pendingLogout) {
            pendingLogout = Promise.resolve().then(logout).finally(() => {
                pendingLogout = null;
            });
        }
        return pendingLogout;
    };

    return async function handleFailure(error) {
        const config = error.config;
        const url = (config && config.url) || "";
        const isAuthRequest = /(?:^|\/)(?:login|logout)(?:[/?]|$)/.test(url);
        if (!error.response || error.response.status !== 401 || !config || isAuthRequest || !getToken()) {
            throw error;
        }

        if (config._authRetry) {
            await endSession();
            throw error;
        }
        config._authRetry = true;

        const token = getToken();
        // A delayed response may belong to the token already renewed by another request.
        if (!config._authToken || config._authToken === token) {
            if (!pendingRefresh) {
                pendingRefresh = Promise.resolve().then(refresh).catch(async refreshError => {
                    const status = refreshError.response && refreshError.response.status;
                    if (getToken() === token && (status === 400 || status === 401)) {
                        await endSession();
                    }
                    throw refreshError;
                }).finally(() => {
                    pendingRefresh = null;
                });
            }
            await pendingRefresh;
        }

        const renewedToken = getToken();
        if (!renewedToken) {
            throw error;
        }
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${renewedToken}`;
        return client(config);
    };
}
